import './Skills.scss'
import React, {useState, useEffect} from 'react'
import { motion, useMotionValue, useSpring } from "framer-motion";
import { distance } from "@popmotion/popcorn";
import {AppWrap} from '../../wrapper'
import {urlFor, client} from '../../client'
import ReactTooltip from 'react-tooltip'
import MotionWrap from '../../wrapper/MotionWrap'


const grid = [[0, 1, 2], [4, 5, 6],[7, 8, 9],[10, 11, 12],[13, 14, 15]]

const Square = ({ active, setActive, colIndex, rowIndex, x, y,skill,index }) => {
  const isDragging = colIndex === active.col && rowIndex === active.row
  const d = distance(
    { x: active.col, y: active.row },
    { x: colIndex, y: rowIndex }
  )
  const springConfig = {
    stiffness: Math.max(700 - d * 120, 0),
    damping: 20 + d * 5
  }
  const dx = useSpring(x, springConfig)
  const dy = useSpring(y, springConfig)
  return (
    <motion.div
    whileInView={{opacity: [0,1]}}
    transition={{duration:0.5}}
    className='app__skills-item app__flex'
  >
      <motion.div className='app__flex test' 
        drag
        dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
        dragTransition={{ bounceStiffness: 500, bounceDamping: 20 }}
        dragElastic={1}
        onDragStart={() => setActive({ row: rowIndex, col: colIndex })}
        style={{
          background: skill[index].bgColor,
          position: "absolute",
          x: isDragging ? x : dx,
          y: isDragging ? y : dy,
          zIndex: isDragging ? 1 : 0
        }}>
        <motion.img
              drag
              dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
              dragTransition={{ bounceStiffness: 500, bounceDamping: 20 }}
              dragElastic={1}
              onDragStart={() => setActive({ row: rowIndex, col: colIndex })}
              style={{
                position: "absolute",
              }} 
              src={urlFor(skill[index].icon)} alt={skill[index].name} />
        
      </motion.div>
      <p className='p-text'>{skill[index].name}</p>
    </motion.div>
    
  );
};



const Skills = () => {
  const [active, setActive] = useState({ row: 0, col: 0 })
  const x = useMotionValue(0)
  const y = useMotionValue(0)
  const [experience, setExperience] = useState([])
  const [skills, setSkills] = useState([])
  let index = -1

  useEffect(() => {
    console.log('useEffect')
    const query = '*[_type == "experiences"]'
    const skillsQuery = '*[_type == "skills"]'

    client.fetch(query)
      .then((data)=>{
        setExperience(data)
      })

    client.fetch(skillsQuery)
    .then((data)=>{
      setSkills(data)
    })

  }, [])

  return (
    <>
      <h2 className='head-text'>Skills & Experience</h2>
      <div className='app__skills-container'>
        <motion.div className='app__skills-list' style={{perspective: 500}}>
        {skills[0] && 
          grid.map((row, rowIndex) =>
            row.map((_item, colIndex) => (
              index +=1,
              <Square
                x={x}
                y={y}
                active={active}
                setActive={setActive}
                rowIndex={rowIndex}
                colIndex={colIndex}
                key={rowIndex + colIndex}
                skill={skills}
                index={index}
              />
            ))
          )}
      </motion.div>
          

        <motion.div className='app__skills-exp'>

            {experience?.map((experience)=>(
              <motion.div className='app__skills-exp-item' key={experience.year}>
                <div className='app__skills-exp-year'>
                  <p className='bold-text'>{experience.year}</p>
                </div>

                <motion.div className='app__skills-exp-works'>
                  {experience.works.map((work)=>(
                    <>
                      <motion.div
                        whileInView={{opacity: [0,1]}}
                        transition={{duration:0.5}}
                        className='app__skills-exp-work'
                        data-tip
                        data-for={work.name}
                        key={work.name}
                      >
                        <h4 className='bold-text'>{work.name}</h4>
                        <p className='p-text'>{work.company}</p>
                      </motion.div>
                      <ReactTooltip
                        id={work.name}
                        effect="solid"
                        arrowColor='#fff'
                        className='skills-tooltip'
                      >
                        {work.desc}
                      </ReactTooltip>
                    </>
                  ))}
                </motion.div>
              </motion.div>
            ))}
        </motion.div>

      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  "app__whitebg")